module.exports = __webpack_public_path__ + "img/photo-19.245776e5.webp";